import { render, staticRenderFns } from "./UniversalTable.vue?vue&type=template&id=34167956&scoped=true"
import script from "./UniversalTable.vue?vue&type=script&setup=true&lang=js"
export * from "./UniversalTable.vue?vue&type=script&setup=true&lang=js"
import style0 from "./UniversalTable.vue?vue&type=style&index=0&id=34167956&prod&lang=css"
import style1 from "./UniversalTable.vue?vue&type=style&index=1&id=34167956&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34167956",
  null
  
)

export default component.exports